import { MantineProvider } from '@mantine/core';
import { ModalsProvider } from '@mantine/modals';
import { Notifications } from '@mantine/notifications';
import { NavigationProgress } from '@mantine/nprogress';
import React, { PropsWithChildren } from 'react';

import mantineTheme from '@/styles/mantine-theme';

const ThemeProvider: React.FC<PropsWithChildren> = ({ children }) => {
  return (
    <MantineProvider theme={mantineTheme}>
      <ModalsProvider>
        <Notifications position="top-right" />
        <NavigationProgress />
        {children}
      </ModalsProvider>
    </MantineProvider>
  );
};

export default ThemeProvider;
